<!-- TODO: we need to refactor the content into the new Sitefinity way. We should do this work when we pick up the tablets, wearables, and phones diagnostics work again. The PBI is here: https://dev.azure.com/AIZ-Global/GT.Digital-ADP/_workitems/edit/2615911 -->

<div class="outer-container">
  <div class="inner-container">
    <div class="header-container">
      <div class="loader" *ngIf="loadingResults$ | async">
        <div class="result-loader"></div>
      </div>      
      <mat-icon [svgIcon]="'success'" *ngIf="!(loadingResults$ | async) && submitSuccess" class="success-icon"></mat-icon>
      <mat-icon [svgIcon]="'error-warning'" *ngIf="!(loadingResults$ | async) && showRetry"></mat-icon>
    </div>
    <h1>
      <adp-label labelKey="PostDiagnostic_Page_Loading_Title" *ngIf="loadingResults$ | async"></adp-label>
      <adp-label labelKey="PostDiagnostic_Page_Title" *ngIf="!(loadingResults$ | async) && submitSuccess"></adp-label>
      <adp-label labelKey="PostDiagnostic_Page_Retry_Title" *ngIf="!(loadingResults$ | async) && showRetry"></adp-label>
    </h1>
    <div class="body">
      <adp-label labelKey="PostDiagnostic_Page_Loading_Message" *ngIf="loadingResults$ | async"></adp-label>
      <adp-label labelKey="PostDiagnostic_Page_Success_Message" *ngIf="!(loadingResults$ | async) && submitSuccess"></adp-label>
      <adp-label labelKey="PostDiagnostic_Page_Retry_Message" *ngIf="!(loadingResults$ | async) && showRetry"></adp-label>
    </div>
    <button mat-flat-button *ngIf="!(loadingResults$ | async) && showRetry" class="retry" color="accent" (click)="retrySubmit()">
      <adp-label labelKey="Global_Button_Retry"></adp-label>
    </button>
    <a *ngIf="!(loadingResults$ | async) && (submitSuccess || showRetry)" class="back-login" href="javascript:void(0)" (click)="gotoLogin()">
      <adp-label labelKey="PostDiagnostic_Page_Close_Window_Button"></adp-label>
    </a>
  </div>
</div>